import { useEffect, useState } from "react";
import { TextField } from "@components/FormsV2";
import ScopeStackModal from "@components/ScopeStackModal/ScopeStackModal";

interface InitialValues {
  name: string;
  redirectUri: string;
}

interface Props {
  show: boolean;
  mode: "create" | "edit";
  initialValues?: InitialValues;
  onClose: () => void;
  onSubmit: (values: { name: string; redirectUri: string }) => void;
  isSubmitting: boolean;
}

const CredentialFormModal = ({
  show,
  mode,
  initialValues,
  onClose,
  onSubmit,
  isSubmitting,
}: Props): JSX.Element => {
  const [name, setName] = useState("");
  const [redirectUri, setRedirectUri] = useState("");

  useEffect(() => {
    if (show) {
      setName(initialValues?.name ?? "");
      setRedirectUri(initialValues?.redirectUri ?? "");
    }
  }, [show, initialValues]);

  const isEdit = mode === "edit";
  const title = isEdit ? "Edit Client Credential" : "New Client Credential";
  const submitVerb = isEdit ? "Save" : "Create";
  const submitInProgress = isEdit ? "Saving…" : "Creating…";

  const helperStyle: React.CSSProperties = {
    display: "block",
    marginTop: "-8px",
    marginBottom: "12px",
    color: "#6c757d",
    fontSize: "12px",
  };

  const body = (
    <>
      <TextField
        id="credential-name"
        label="*Name"
        value={name}
        placeholder="e.g., Datadog forwarder"
        onChange={(e) => setName(e.target.value)}
      />
      <small style={helperStyle}>
        A description of the use of this credential
      </small>
      <TextField
        id="credential-redirect-uri"
        label="Redirect URI"
        value={redirectUri}
        placeholder="https://..."
        onChange={(e) => setRedirectUri(e.target.value)}
      />
      <small style={helperStyle}>
        Recommended: the location of the server that will make calls to the API
        or MCP servers
      </small>
    </>
  );

  return (
    <ScopeStackModal
      show={show}
      modalTitle={title}
      modalBody={body}
      handleClose={onClose}
      button1Text="Cancel"
      handleButton1Click={onClose}
      button2Text={isSubmitting ? submitInProgress : submitVerb}
      handleButton2Click={() =>
        onSubmit({ name: name.trim(), redirectUri: redirectUri.trim() })
      }
      button2Disabled={!name.trim() || isSubmitting}
    />
  );
};

export default CredentialFormModal;
